/** Display helpers for event pricing markets (LOCAL = Rs., INTERNATIONAL = USD). */

export function normalizePricingMarket(value) {
  const upper = String(value || 'LOCAL').trim().toUpperCase();
  return upper === 'INTERNATIONAL' ? 'INTERNATIONAL' : 'LOCAL';
}

export function priceCurrencyForMarket(market) {
  return normalizePricingMarket(market) === 'INTERNATIONAL' ? 'USD' : 'LKR';
}

export function marketLabel(market) {
  return normalizePricingMarket(market) === 'INTERNATIONAL' ? 'International (USD)' : 'Local (Rs.)';
}

export function marketShortLabel(market) {
  return normalizePricingMarket(market) === 'INTERNATIONAL' ? 'International' : 'Local';
}

export function formatMarketMoney(amount, market, { locale } = {}) {
  const n = Number(amount || 0);
  const m = normalizePricingMarket(market);
  const opts = { minimumFractionDigits: 2, maximumFractionDigits: 2 };
  if (m === 'INTERNATIONAL') {
    return `USD ${n.toLocaleString(locale || 'en-US', opts)}`;
  }
  return `Rs. ${n.toLocaleString(locale || 'en-LK', opts)}`;
}
